import PropTypes from "prop-types";
import ProductTilePlaceholder from "../ProductTilePlaceholder";
import LazyLoadObserver from "../../../containers/common/LazyLoadObserver";
import { isFullyLoaded } from "../../../../state/modules/savedItems/selectors/itemStateSelectors";
import SavedItemsProductTileList from "../../../containers/common/SavedItemsProductTileList";
import isLastBestPriceEnabled from "../../common/SavedItemsProductTiles/isLastBestPriceEnabled";
import AppDownloadBanner from "../../common/AppDownloadBanner";
import useMatchMedia from "../../common/useMatchMedia";
import media from "../../../../styles/customMedia.json";
import webContextProvider from "../../../../providers/webContextProvider";

import { isTablet } from "./utils";

const SavedItemsProductTiles = ({
  savedItems,
  ProductTile,
  showDiscountLabel,
  isAuthenticated
}) => {
  const {
    customMedia: { ["--large-viewport"]: largeViewport }
  } = media;

  const showExtendedPricing = isLastBestPriceEnabled();
  const isLargeViewport = useMatchMedia(largeViewport);
  const { platform } = webContextProvider();

  const isTab = isTablet();

  return (
    <>
      <SavedItemsProductTileList>
        {savedItems.map((item, index) => (
          <li key={item.id}>
            {isFullyLoaded(item) ? (
              <ProductTile
                {...{
                  ...item,
                  index,
                  showDiscountLabel,
                  showExtendedPricing,
                  isAuthenticated
                }}
              />
            ) : (
              <ProductTilePlaceholder itemState={item.itemState} />
            )}
          </li>
        ))}
        {savedItems.length > 0 && (
          <>
            {isLargeViewport && platform === "desktop" && !isTab && (
              <li>
                <AppDownloadBanner />
              </li>
            )}
          </>
        )}
      </SavedItemsProductTileList>
      <LazyLoadObserver />
    </>
  );
};

SavedItemsProductTiles.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default SavedItemsProductTiles;
